const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftRecordsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Shift Records Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7548",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.577 190.175h7.245v-1.35h-7.245zm0-3.825h7.245V185h-7.245zM161.35 194a1.384 1.384 0 0 1-1.35-1.35v-15.3a1.384 1.384 0 0 1 1.35-1.35h8.122l4.927 4.928v11.722a1.384 1.384 0 0 1-1.35 1.35zm7.447-12.465v-4.185h-7.447v15.3h11.7v-11.115zm-7.447-4.185z",
    transform: "translate(-155.2 -173)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftRecordsIcon);
export default __webpack_public_path__ + "static/media/shift-records-icon.7f0f603e48fa7d52e77c863d35cf9bcc.svg";
export { ForwardRef as ReactComponent };